var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('OrganismHeader',{on:{"search":(data) => (_vm.search = data)}}),_c('OrganismContent',{attrs:{"search":_vm.search}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }